'use client';

import { DATE_YYYY_MM_DD } from '@th/shared/src/constants/dateTimes';
import {
  SimpleListing,
  SimpleListingObject,
} from '@th/shared/src/types/SimpleListing';
import ListingCardStatusText from './ListingCardStatusText';
import Link from 'next/link';
import { clsx } from 'clsx';
import BlurText from '../BlurText';
import useIsListingBlurred from '../../hooks/useIsListingBlurred';
import LinkWrapper from '../LinkWrapper';

type Props = {
  simpleListingObject: SimpleListingObject;
  isClickable: boolean;
};

export default function ListingHistoryItem({
  simpleListingObject,
  isClickable,
}: Props) {
  const simpleListing = SimpleListing.fromObject(simpleListingObject);
  const isBlurred = useIsListingBlurred(simpleListing);

  return (
    <div className="max-w-md">
      <LinkWrapper href={`/l/${simpleListing.id}`} disabled={!isClickable}>
        <div
          className={`flex rounded-lg py-2 px-4 my-1 
        ${
          isClickable
            ? 'border border-lightGray hover:bg-lightestPrimary'
            : 'bg-lighterPrimary'
        }`}
        >
          <div className="w-full">
            <div className="flex flex-row">
              <p className={clsx('mr-5', isBlurred && 'blur-md')}>
                {simpleListing.latestPrice().formatAsPrice()}
              </p>
              <ListingCardStatusText
                listing={simpleListing}
                isBlurred={isBlurred}
              />
            </div>
            <div className="flex flex-row justify-between">
              <p className="text-sm text-secondaryText">
                Date:{' '}
                <BlurText isBlurred={isBlurred}>
                  {simpleListing.listDate.toFormat(DATE_YYYY_MM_DD)}
                </BlurText>
              </p>
              <p className="text-sm text-secondaryText ">
                {simpleListing.mlsNumber}
              </p>
            </div>
          </div>
        </div>
      </LinkWrapper>
    </div>
  );
}
